const actions = {
  // Listar Papéis
  listarTentativas: async (
    context,
    { vendor_id, data_inicial, data_final, search, mola, produto, nome_maquina }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `/machine/relatorio/tentativas-malsucedidas`,
      {
        params: {
          vendor_id,
          data_inicial,
          data_final,
          search,
          mola,
          produto,
          nome_maquina,
        },
      }
    );
    return response;
  },
  listar: async (context, { vendor_id, search }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`/machine`, {
      params: {
        vendor_id,
        search,
      },
    });
    return response;
  },
  atualizar: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `/machine/mensagem-firebase/generica/${id}/updateWithMultpex`
    );
    return response;
  },

  sincronizar: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `/machine/mensagem-firebase/generica/${id}/sync`
    );
    return response;
  },
  acompanhar: async (context, { id, users }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/machine/detach-user/${id}`, {
      machine_id: id,
      users,
    });
    return response;
  },

  exportar: async (context, { vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(
      `/machine/relatorio/tentativas-malsucedidas`,
      {
        params: {
          download: "excel",
          vendor_id,
        },
      }
    );
    return response;
  },

  getQr: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/machine/qrcode`, {
      params: {
        machine_id: id,
      },
    });
    return response;
  },
  criarQr: async (context, { titulo, link, id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/machine/qrcode`, {
      machine_id: id,
      titulo,
      link,
    });
    return response;
  },

  getMachine: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/machine/${id}`);
    return response;
  },
  setMachineStock: async (context, { id, products }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/machine/set-minimal-stock/${id}`, {
      machine_id: id,
      products,
    });
    return response;
  },
  getMensagens: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(
      `/machine/relatorio/recuperar-mensagem/${id}`
    );
    return response;
  },
  setMensagensValue: async (context, { id, key, value }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/machine/auto/gravar-mensagem`, {
      machine_id: id,
      key,
      value,
    });
    return response;
  },
  getLogs: async (context, { ids, data_inicial, data_final }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(
      `/machine/relatorio/tentativas-malsucedidas`,
      {
        params: {
          ids,
          data_inicial,

          data_final,
        },
      }
    );
    return response;
  },

  receberTelemetriaMaquina: async (
    context,
    { data_inicial, data_final, machine_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`machine/relatorio/telemetria-athena`, {
      params: {
        data_inicial,
        data_final,
        machine_id,
      },
    });
    return response;
  },
};

export const maquina = {
  namespaced: true,
  actions,
};
